module.exports = __webpack_public_path__ + "a34e75a389f7082a82c7aa495bb864fd.glb";